import { extendTheme, THEME_DARK, THEME_DEFAULT } from '@tinderapp/ui-core';

/**
 * Sandbox Themes
 * ==============
 *
 * This allows you to add any keys you want to the theme outside of the Design System. This file
 * defines "sandbox" themes that start with the tokens of the Design System and are augmented with
 * preliminary/experimental/whatever tokens that are implemented on a trial basis.
 *
 * This will most likely be used for colors and gradients. New tokens should be added to both
 * `THEME_SANDBOX_LIGHT` and `THEME_SANDBOX_DARK` to ensure that they work across modes.
 *
 * Don't abuse the sandbox! This is not the place for overrides or long-term design tokens; it's a
 * courtesy to prevent the more methodical Design System process from blocking feature development.
 *
 * EXAMPLE:
 *
 * const THEME_SANDBOX_LIGHT = extendTheme(THEME_DEFAULT, {
 *   color: {
 *     yourCoolColor: COLOR_GRAY_15,
 *   },
 *   gradient: {
 *     yourCoolGradient: {
 *       angle: 45,
 *       colors: [COLOR_GRAY_80, COLOR_GRAY_15]
 *     }
 *   }
 * });
 *
 * const THEME_SANDBOX_DARK = extendTheme(THEME_DEFAULT, {
 *   color: {
 *     yourCoolColor: COLOR_GRAY_80,
 *   },
 *   gradient: {
 *     yourCoolGradient: {
 *       angle: 45,
 *       colors: [COLOR_GRAY_80, COLOR_GRAY_80]
 *     }
 *   }
 * });
 */

const THEME_SANDBOX_LIGHT = extendTheme(THEME_DEFAULT, {
  color: {},
  gradient: {},
});

const THEME_SANDBOX_DARK = extendTheme(THEME_DARK, {
  color: {},
  gradient: {},
});

export { THEME_SANDBOX_LIGHT as THEME_DEFAULT, THEME_SANDBOX_DARK as THEME_DARK };
